import { css, styled, Switch } from '@mui/material';

export const SSwitch = styled(Switch)(
  ({ theme }) => css`
    width: 36px;
    height: 20px;
    padding: 0;

    .MuiSwitch-switchBase {
      padding: 0;
      margin: 2px;
      transition-duration: 300ms;

      &.Mui-checked {
        transform: translateX(16px);
        color: ${theme.palette.common.white};

        & + .MuiSwitch-track {
          background-color: ${theme.palette.primary[600]};
          opacity: 1;
          border: 0;
        }

        &.Mui-disabled + .MuiSwitch-track {
          opacity: 0.5;
        }
      }

      &.Mui-focusVisible .MuiSwitch-thumb {
        color: ${theme.palette.primary[600]};
        border: 6px solid ${theme.palette.common.white};
      }

      &.Mui-disabled .MuiSwitch-thumb {
        color: ${theme.palette.grey[200]};
      }

      &.Mui-disabled + .MuiSwitch-track {
        opacity: 0.7;
      }
    }

    .MuiSwitch-thumb {
      box-sizing: border-box;
      width: 16px;
      height: 16px;
    }

    .MuiSwitch-track {
      border-radius: 13px;
      background-color: ${theme.palette.grey[200]};
      opacity: 1;
      transition: ${theme.transitions.create(['background-color'], {
        duration: 500,
      })};
    }
  `,
);
